<template>
  <v-container>
    <v-row
        class="d-flex justify-center"
    >

      <v-dialog
          v-model="show"
          :width="loading ? 250 : width"
          :persistent="!closable"
          @click:outside="$emit('outsideClick')"
      >

        <v-card v-if="loading">

          <v-card-text class="text-center d-flex flex-column justify-center align-center">

            <div
                class="d-flex justify-center mb-3 pt-3 mx-auto"
            >
              <v-img
                  src="sms.ico"
                  max-height="80"
                  max-width="80"
                  contain
              />
            </div>

            <p class="font-weight-bold font-size-h4 ">
              {{ i18n.t('Loading.Waiting') }} ...
            </p>
            <div>

            </div>


            <half-circle-spinner
                class="mx-auto mt-10"
                :animation-duration="1000"
                :size="50"
                color="#8b8e94"
            />

          </v-card-text>



          <p class="text-center mb-0 description">{{i18n.t('Loading.Description')}}</p>
          <v-divider class="my-0 py-0"></v-divider>

          <v-card-actions class="d-flex justify-center">

<!--            <hollow-dots-spinner-->
<!--                :animation-duration="1000"-->
<!--                :dot-size="15"-->
<!--                :dots-num="3"-->
<!--                color="#8b8e94"-->

<!--            />-->
            <!--          color="#ff1d5e"-->
<!--          <p class="text-center">کور لند</p>-->
          </v-card-actions>
        </v-card>

        <v-card v-else> <slot/> </v-card>

      </v-dialog>

    </v-row>
  </v-container>


</template>

<script>
import {HollowDotsSpinner} from 'epic-spinners'
import { HalfCircleSpinner } from 'epic-spinners'

import i18n from "../../i18n";
export default {
  name: "WaitStatusDialog",
  components: {HollowDotsSpinner ,HalfCircleSpinner},
  props: {
    show: {
      type: false,
      default: false
    },
    closable: true,
    loading : {
      type:Boolean,
      default:true
    },
    width : {
      default: 500
    }
  },
  data(){
    return{
      i18n
    }
  },
  watch: {
    show(n, o) {
      this.$emit("onShowChange", n)
    }
  }
}
</script>

<style scoped>
.description{
  font-size: 0.7rem;
  color: darkgray;
}
</style>